export * from './lib/ui-bottom-navbar.module';
